import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _castArray from 'lodash/castArray';

var addToRenderOptions = function addToRenderOptions(field, options) {
  var derivedOptions = _castArray(options);

  var returnObj = _objectSpread(_objectSpread({}, field), {}, {
    renderOptions: _objectSpread({}, field.renderOptions)
  });

  derivedOptions.forEach(function (option) {
    returnObj.renderOptions[option.path] = option.value;
  });
  return returnObj;
};

export default addToRenderOptions;